import * as React from 'react';
import clsx from 'clsx';

import * as styles from './RecommendationDesktopSkeleton.css';

export const RecommendationDesktopSkeleton: React.FC = () => (
  <div className={styles['container']} data-name="RedesignedRecommendationDesktopSkeleton">
    <div className={clsx(styles['skeleton'], styles['image'])} />
    <div className={styles['content']}>
      <div>
        <div className={clsx(styles['skeleton'], styles['primary-line'])} />
        <div className={styles['skeleton']} />
      </div>
      <div className={styles['location']}>
        <div className={styles['skeleton']} />
        <div className={styles['skeleton']} />
      </div>
    </div>
  </div>
);
